
import Vue from "vue";
import eventBus from "@/eventBus";

export default Vue.extend({
  data() {
    return {
      show: false,
      message: "",
      timer: null as any,
    };
  },
  mounted() {
    eventBus.$on("snackbar", (opts: { message: string }) => {
      this.message = opts.message;
      this.show = true;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.show = false;
      }, 4000);
    });
  },
  beforeDestroy() {
    eventBus.$off("snackbar");
  },
});
